// extracted by mini-css-extract-plugin
export default {"slideshow":"MultiChoiceResponse__slideshow___YSSR7"};